// extracted by mini-css-extract-plugin
export default {"row":"policies_row__NTxfp"};